import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/268VIcon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-850d844c")

_pushScopeId("data-v-850d844c")
const _hoisted_1 = { class: "toc_ui__headTip_main" }
const _hoisted_2 = {
  class: "toc_ui__head_content",
  id: "headMainTop"
}
const _hoisted_3 = { class: "toc_ui__headTip_content_report" }
const _hoisted_4 = {
  key: 0,
  class: "logo-icon"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "logo-icon"
}
const _hoisted_7 = { class: "toc_ui__headTip_content_report_text" }
const _hoisted_8 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_9 = { class: "toc_ui__headTip_content_result" }
const _hoisted_10 = { class: "toc_ui__headTip_content_result_title" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 此车已经过专业认证机构检测认证 ")
const _hoisted_12 = { class: "toc_ui__headTip_content_result_flexbox" }
const _hoisted_13 = { class: "toc_ui__headTip_content_result_item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, " 非重大事故车 ", -1)
const _hoisted_15 = { class: "toc_ui__headTip_content_result_item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, " 非火烧车 ", -1)
const _hoisted_17 = { class: "toc_ui__headTip_content_result_item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, " 非泡水车 ", -1)
const _hoisted_19 = { class: "toc_ui__headTip_content_result_item" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, " 非重大事故车 ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "hlTxt" }, " 重大事故车 ", -1)
const _hoisted_22 = { class: "toc_ui__headTip_content_result_item" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", null, " 非火烧车 ", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "hlTxt" }, " 火烧车 ", -1)
const _hoisted_25 = { class: "toc_ui__headTip_content_result_item" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", null, " 非泡水车 ", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "hlTxt" }, " 泡水车 ", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "standardTip" }, "质量管理体系符合标准：GB/T 19001-2016/ISO 9001:2015", -1)
const _hoisted_29 = {
  key: 0,
  class: "buyCarTip"
}
const _hoisted_30 = { class: "buyCarTipItem buyCarTipItem-jian" }
const _hoisted_31 = {
  key: 0,
  class: "buyCarTipItem buyCarTipItem-bao mt10"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "车况符合准入条件，付费可享受最低1年3万公里保修", -1)
const _hoisted_33 = { class: "toc_ui__headTip_main_chekuang" }
const _hoisted_34 = { class: "toc_ui__headTip_content_report_num" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.state.channelType !== 'lingshou')
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _hoisted_5
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("img", {
                  class: "lingshou",
                  src: _ctx.state.logoUrl
                }, null, 8, ["src"])
              ])),
          _createVNode("div", _hoisted_7, " 检测" + _toDisplayString(_ctx.state.reportMsg.RpSRZ() ? '质保双' : '') + "认证评估报告 ", 1),
          _createVNode("div", _hoisted_8, " NO. " + _toDisplayString(_ctx.state.reportCode), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("img", {
              class: "safeImg",
              src: require('@/assets/toc/safe.png')
            }, null, 8, ["src"]),
            (_ctx.state.channelType === 'lingshou')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_11
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.state.point === 'N')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("此车通过268V买车无忧" + _toDisplayString(_ctx.state.reportMsg.RpSRZ() ? '检双' :'检') + "认证", 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("此车未通过268V买车无忧" + _toDisplayString(_ctx.state.reportMsg.RpSRZ() ? '检双' :'检') + "认证", 1)
                      ], 64))
                ], 64))
          ]),
          _createVNode("div", _hoisted_12, [
            (_ctx.state.point === 'N')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("img", {
                      src: require('@/assets/toc/noAccidentCar.png')
                    }, null, 8, ["src"]),
                    _hoisted_14
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("img", {
                      src: require('@/assets/toc/noFireCar.png')
                    }, null, 8, ["src"]),
                    _hoisted_16
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("img", {
                      src: require('@/assets/toc/noWaterCar.png')
                    }, null, 8, ["src"]),
                    _hoisted_18
                  ])
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("div", _hoisted_19, [
                    (!_ctx.state.isAccident)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode("img", {
                            src: require('@/assets/toc/noAccidentCar.png')
                          }, null, 8, ["src"]),
                          _hoisted_20
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode("img", {
                            src: require('@/assets/toc/accidentCar.png')
                          }, null, 8, ["src"]),
                          _hoisted_21
                        ], 64))
                  ]),
                  _createVNode("div", _hoisted_22, [
                    (!_ctx.state.isFire)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode("img", {
                            src: require('@/assets/toc/noFireCar.png')
                          }, null, 8, ["src"]),
                          _hoisted_23
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode("img", {
                            src: require('@/assets/toc/fireCar.png')
                          }, null, 8, ["src"]),
                          _hoisted_24
                        ], 64))
                  ]),
                  _createVNode("div", _hoisted_25, [
                    (!_ctx.state.isWater)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode("img", {
                            src: require('@/assets/toc/noWaterCar.png')
                          }, null, 8, ["src"]),
                          _hoisted_26
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode("img", {
                            src: require('@/assets/toc/waterCar.png')
                          }, null, 8, ["src"]),
                          _hoisted_27
                        ], 64))
                  ])
                ], 64))
          ]),
          _hoisted_28
        ]),
        (_ctx.state.point === 'N')
          ? (_openBlock(), _createBlock("ul", _hoisted_29, [
              _createVNode("li", _hoisted_30, [
                _createVNode("img", {
                  class: "title",
                  src: require('@/assets/toc/mcwyj.png')
                }, null, 8, ["src"]),
                _createVNode("span", {
                  innerHTML: _ctx.state.promiseMsg
                }, null, 8, ["innerHTML"]),
                _createVNode("img", {
                  class: "arrow",
                  src: require('@/assets/toc/arrow.png'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toExplain('check')))
                }, null, 8, ["src"])
              ]),
              (_ctx.state.reportMsg.RpSRZ())
                ? (_openBlock(), _createBlock("li", _hoisted_31, [
                    _createVNode("img", {
                      class: "title",
                      src: require('@/assets/toc/mcwyb.png')
                    }, null, 8, ["src"]),
                    _hoisted_32,
                    _createVNode("img", {
                      class: "arrow",
                      src: require('@/assets/toc/arrow.png'),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toExplain('auth')))
                    }, null, 8, ["src"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !_ctx.state.reportMsg.RpZB() && !_ctx.state.reportMsg.RpCK()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_33, [
      _createVNode("img", {
        class: "chekuangLogo",
        src: require('@/assets/toc/chekuangLogo.png'),
        alt: ""
      }, null, 8, ["src"]),
      _createVNode("div", _hoisted_34, " NO. " + _toDisplayString(_ctx.state.reportCode), 1)
    ], 512), [
      [_vShow, _ctx.state.reportMsg.RpCK()]
    ])
  ]))
})